/* eslint-disable @typescript-eslint/no-explicit-any */


import { QueryParams, StringParam } from 'use-query-params';
import { IPaginationQueryParams, getPaginationQueryParams } from '../common/constants/pagination';
import { OrderDirection } from '../common/enums/order-direction.enum';
import { IHOCQueryProps } from '../common/interfaces/IHOCQueryProps';
import { CompanyStatus } from '../common/interfaces/company.interface';
import CompanyTable from './CompaniesTable';

export interface CompanyTableQueryPrps extends IPaginationQueryParams {
    search?: string;
    status?: CompanyStatus
}

export type CompanyTableBasicProps = IHOCQueryProps<CompanyTableQueryPrps>;

const DEFAULT_QUERY_PARAMS = getPaginationQueryParams({
    orderBy: 'created_at',
    orderDirection: OrderDirection.DESC,
});

const CompanyTableWithQueryParams = () => {
    const queryConfig = {
        ...DEFAULT_QUERY_PARAMS,
        search: StringParam,
        status: StringParam,
    };

    return (
        <QueryParams config={queryConfig}>
            {(props: any) => {
                return <CompanyTable {...props} />;
            }}
        </QueryParams>
    );
};

export default CompanyTableWithQueryParams;
